import cronJobPayloadSchema from 'root/src/shared/descriptions/endpoints/schemas/requestSchemas/cronJobPayloadSchema';
import { creatorConstants } from 'root/src/shared/creator/creator.constants';
export const sendTopCreatorsMailEndpoint = {
    [creatorConstants.SEND_TOP_CREATORS_MAIL]: {
        payloadSchema: cronJobPayloadSchema,
        isCron: true,
    },
};
